import {
    PriceTypeEnum,
} from "ReactApp/Types/enum";
import React from 'react';
import { observer } from "mobx-react";
import ImageV1 from 'ReactApp/Components/ImageV1/ImageV1';
import BadgeListV1 from 'ReactApp/Components/BadgeListV1/BadgeListV1';
import LinkV1 from 'ReactApp/Components/LinkV1/LinkV1';
import PriceBlockV2 from 'ReactApp/Components/PriceBlockV2/PriceBlockV2';
import { CartNs } from 'ReactApp/Types/CartNs';
import { DomainNs } from "ReactApp/Types/DomainNs";

type ProductCardV7AsCartGiftV1Props = {
    gift: CartNs.GiftInterface,
    card: DomainNs.ProductCardV6Interface,
}

const ProductCardV7AsCartGiftV1 = observer((props: ProductCardV7AsCartGiftV1Props) => {

    const renderGiftTitle = (): string | React.JSX.Element => {
        return (
            <>
                Ваш подарок: {(props.gift.giftRow.productInfo.title as string)},
                &nbsp;
                <strong>
                    {
                        (props.gift.giftRow.commonCount as number) 
                            * 
                        (props.card.cartInfo.number || 1)
                    } шт.
                </strong>
            </>
        );
    } 

    return (
        <div className="product-card-v7 product-card-v7-as-cart-gift-v1">
            <div className="product-card-v7__badge-column">
                <BadgeListV1 {...{
                    badges: [
                        {
                            iconProps: {
                                svgSpriteId: 'gift-icon',
                                width: 21,
                                height: 21,
                            },
                            classes: [
                                'badge-v1_filling-type-contained',
                                'badge-v1_filling-color-type-text',
                                'badge-v1_filling-color-type-white',
                                'badge-v1_text-color-type-white',
                            ],
                        }
                    ]
                }} />
            </div>
            <div className="product-card-v7__image-column">
                {props.gift.giftRow.productInfo.image !== null && (
                    <ImageV1 {...{
                        src: (props.gift.giftRow.productInfo.image as string),
                        loading: 'lazy'
                    }} />
                )}
            </div>
            <div className="product-card-v7__title-column">
                <LinkV1 {...{
                    href: (props.gift.giftRow.productInfo.url as string),
                    label: renderGiftTitle(),
                    classes: [
                        'link-v1_text-color-type-text',
                        'link-v1_decoration-type-none'
                    ]
                }} />
            </div>
            <div className="product-card-v7__price-column">
                <PriceBlockV2 {...{
                    salePrice: {
                        priceType: PriceTypeEnum.sale,
                        value: 0,
                        key: '',
                        baseCardKey: '',
                    },
                    oldPrice: {
                        priceType: PriceTypeEnum.old,
                        value: (props.gift.giftRow.productInfo.oldPrice as number),
                        key: '',
                        baseCardKey: '',
                    },
                    isGift: true,
                }} />
            </div>
            <div className="product-card-v7__action-column"></div>
        </div>
    );

})

export default ProductCardV7AsCartGiftV1;